<app-assinatura-digital-download-de-conteudo
 [idAssinaturaDigitalEvento]="idAssinaturaDigitalEvento">
</app-assinatura-digital-download-de-conteudo>

<app-lista 
  #lista
  [controller]="this" 
  [exibirLegenda]="false">
</app-lista>